import React from 'react';
import './StatsStrip.css';

const stats = [
  { value: '15', suffix: '+', label: 'Years MNC Leadership' },
  { value: '50', suffix: '+', label: 'Companies Served' },
  { value: '5', suffix: '+', label: 'Years International BD' },
  { value: '+46', suffix: '%', label: 'Peak Revenue Growth (Year 2)' },
  { value: '2', suffix: '–4wk', label: 'Engagement Launch Time', split: true },
  { value: '3', suffix: '', label: 'Global Regions' },
];

const StatsStrip = () => (
  <div id="strip">
    <div className="stri">
      {stats.map((stat, i) => (
        <React.Fragment key={stat.label}>
          {i > 0 && <div className="sts" />}
          <div className="sti">
            <div>
              <div className="stn">
                {stat.split ? (
                  <><span>2</span>–<span>4</span>wk</>
                ) : (
                  <><span>{stat.value}</span>{stat.suffix}</>
                )}
              </div>
              <div className="stl">{stat.label}</div>
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  </div>
);

export default StatsStrip;
